import React from 'react';
import { useAppTheme } from '../../context/ThemeContext';

interface BadgeProps {
  color: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'gray';
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ color, children, className = '' }) => {
  const { themeConfig } = useAppTheme();

  const getBadgeStyles = () => {
    const baseStyles = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
    const colorStyles = {
      primary: {
        bg: themeConfig.primary + '20',
        text: themeConfig.primary
      },
      secondary: {
        bg: themeConfig.secondary + '20',
        text: themeConfig.secondary
      },
      success: {
        bg: themeConfig.success + '20',
        text: themeConfig.success
      },
      error: {
        bg: themeConfig.error + '20',
        text: themeConfig.error
      },
      warning: {
        bg: themeConfig.warning + '20',
        text: themeConfig.warning
      },
      info: {
        bg: themeConfig.primary + '20',
        text: themeConfig.primary
      },
      gray: {
        bg: themeConfig.accent + '20',
        text: themeConfig.text
      }
    };

    const styles = colorStyles[color];
    return `${baseStyles} ${className} bg-[${styles.bg}] text-[${styles.text}]`;
  };

  return (
    <span className={getBadgeStyles()}>
      {children}
    </span>
  );
};

export default Badge; 